<template>
  <ankh-list :show-search-form="false" :show-btn-group="false">
    <template #tab-row>
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in comps" :key="item.name" :label="`${$t(item.label)}（${item.count}）`" :name="item.name">
        </el-tab-pane>
      </el-tabs>
    </template>
    <template #table="{height}">
      <keep-alive>
        <component :is="activeName"/>
      </keep-alive>
    </template>
  </ankh-list>
</template>

<script>
import CollectTool from "@/components/user/CollectTool";
import CollectFood from "@/components/user/CollectFood";
import {request} from "@/config/request";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UserCollectList",
  components: {AnkhList, CollectFood, CollectTool},
  data() {
    return {
      activeName: "CollectTool",
      comps: [
        {label: "收藏的工具", name: "CollectTool", count: 0, key: "tool"},
        {label: "收藏的食物", name: "CollectFood", count: 0, key: "food"}
      ]
    }
  },
  created() {
    this.loadCollectCount();
  },
  methods: {
    // 我的收藏数量统计
    async loadCollectCount() {
      try {
        const res = await request(this.$api.cookToolCollect.countData, {userNum: this.$route.query.num});
        const countData = res.countMap;
        this.comps.map(item => {
          item.count = countData[item.key] || 0;
        })
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>
